import { render } from "./editGoodsCompoents.vue?vue&type=template&id=4382dbf8"
import script from "./editGoodsCompoents.vue?vue&type=script&lang=js"
export * from "./editGoodsCompoents.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__